import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {QueryParamProvider} from 'use-query-params';
import {ReactRouter5Adapter} from 'use-query-params/adapters/react-router-5';
import App from './component/App';
import {IWatchAppModel} from './model/appModel';
import config from './service/config';
import './static/css/index.less';
import StateProvider, {PWCEntryPoint} from './context/stateProvider';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';

export default (model: IWatchAppModel) => {
   const appRoot = document.getElementById('root');
   if (!appRoot) {
      return;
   }

   document.body.classList.add('app-body');

   config.initWatch(model);

   ReactDOM.render(
      <DndProvider backend={HTML5Backend}>
         <BrowserRouter>
            <QueryParamProvider adapter={ReactRouter5Adapter}>
               <StateProvider
                  isOwnerOrAdmin={config.watchConfig.isOwnerAdminOrTeamEditor}
                  entryPoint={PWCEntryPoint.WatchPage}
               >
                  <App watchAppModel={model} />
               </StateProvider>
            </QueryParamProvider>
         </BrowserRouter>
      </DndProvider>,
      appRoot
   );
};
